export const MULTIPLAYER_TRACE_DOC_PREFIX = 'd0cd0c'

export const MULTIPLAYER_TRACE_DEBUG_PREFIX = 'debdeb'

export const MULTIPLAYER_TRACE_DEBUG_SESSION_SHORT_ID_LENGTH = 16

export const MULTIPLAYER_OTEL_DEFAULT_TRACES_EXPORTER_URL = 'https://api.multiplayer.app/v1/traces'

export const MULTIPLAYER_OTEL_DEFAULT_LOGS_EXPORTER_URL = 'https://api.multiplayer.app/v1/logs'

export const MULTIPLAYER_ATTRIBUTE_PREFIX = 'multiplayer.'

export const MULTIPLAYER_MAX_HTTP_REQUEST_RESPONSE_SIZE = process.env.MULTIPLAYER_MAX_HTTP_REQUEST_RESPONSE_SIZE
  ? Number(process.env.MULTIPLAYER_MAX_HTTP_REQUEST_RESPONSE_SIZE)
  : 500000

export const ATTR_MULTIPLAYER_WORKSPACE_ID = 'multiplayer.workspace._id'

export const ATTR_MULTIPLAYER_PROJECT_ID = 'multiplayer.project._id'

export const ATTR_MULTIPLAYER_PLATFORM_ID = 'multiplayer.platform._id'

export const ATTR_MULTIPLAYER_CLIENT_ID = 'multiplayer.client.id'

export const ATTR_MULTIPLAYER_INTEGRATION_ID = 'multiplayer.integration._id'

export const ATTR_MULTIPLAYER_DEBUG_SESSION_ID = 'multiplayer.debug_session._id'

/**
 * @deprecated
 */
export const ATTR_MULTIPLAYER_DEBUG_SESSION = 'multiplayer.debug_session._id'

export const ATTR_MULTIPLAYER_HTTP_REQUEST_BODY = 'multiplayer.http.request.body'

export const ATTR_MULTIPLAYER_HTTP_RESPONSE_BODY = 'multiplayer.http.response.body'

export const ATTR_MULTIPLAYER_HTTP_REQUEST_HEADERS = 'multiplayer.http.request.headers'

export const ATTR_MULTIPLAYER_HTTP_RESPONSE_HEADERS = 'multiplayer.http.response.headers'

export const ATTR_MULTIPLAYER_HTTP_RESPONSE_BODY_ENCODING = 'multiplayer.http.response.body.encoding'

export const MASK_PLACEHOLDER = '***MASKED***'

export const MULTIPLAYER_DEBUG_REQUEST = 'multiplayer-debug-request'
